<span id="myItem">
  <span class="circle" [ngStyle]="{ 'background-color': color }"></span>
  {{ categoryname }}
</span>
